import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero } from '../components/bits';
import { useLead } from '../components/LeadModal';
import { TECH_PHASES, DIGITAL_ASSETS } from '../content/data';

export default function Technical() {
  const { open } = useLead();
  return (
    <div data-testid="technical-page">
    <SEO title="9-Month Technical Excellence Track" description="Web development, cybersecurity, analytics, AI augmentation and a defended technical portfolio." />
      <PageHero
        ck="technical"
        tag="9-Month Technical Excellence Track"
        lines={<>Build. Secure. Analyse. <span className="font-serif italic font-normal text-electric">Automate.</span></>}
        intro="A focused technical programme for learners who want to work closer to the infrastructure, security, data and AI systems behind the digital economy."
      >
        <ArrowBtn onClick={() => open('Student Programmes')} variant="primary" testId="technical-cta-apply">Apply for Technical Track</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap space-y-8">
          {TECH_PHASES.map((p, i) => (
            <Reveal key={p.phase} delay={i * 0.05}>
              <div data-testid={`tech-phase-${i}`} className="grid gap-8 rounded-3xl border border-navy/10 bg-white p-8 sm:p-10 lg:grid-cols-[280px_1fr]">
                <div>
                  <span className="overline !text-[10px] text-electric">{p.phase} · {p.months}</span>
                  <h2 className="text-h3 mt-3 font-semibold">{p.title}</h2>
                </div>
                <ul className="grid content-start gap-2.5 sm:grid-cols-2">
                  {p.items.map((x) => (
                    <li key={x} className="flex items-center gap-2.5 rounded-xl bg-paper px-4 py-3 text-sm font-medium text-navy/80">
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-electric" />{x}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-grid-dark bg-navy py-20 text-white sm:py-28">
        <div className="wrap">
          <SectionTag dark>Technical Assets</SectionTag>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {DIGITAL_ASSETS.map((a, i) => (
              <Reveal key={a.title} delay={i * 0.06} className="rounded-3xl border border-white/10 bg-navy-800/70 p-7">
                <h3 className="text-lg font-semibold tracking-tight text-gold">{a.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-white/60">{a.desc}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-10"><ArrowBtn onClick={() => open('Student Programmes')} variant="gold" testId="technical-cta-apply-bottom">Apply for Technical Track</ArrowBtn></Reveal>
        </div>
      </section>
    </div>
  );
}
